import { render, staticRenderFns } from "./BoxedText.vue?vue&type=template&id=eeb2a416&scoped=true&lang=pug&"
import script from "./BoxedText.vue?vue&type=script&lang=js&"
export * from "./BoxedText.vue?vue&type=script&lang=js&"
import style0 from "./BoxedText.vue?vue&type=style&index=0&id=eeb2a416&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eeb2a416",
  null
  
)

export default component.exports